import React, { useMemo } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { parseMathSegments } from '../../utils/mathDisplay';

interface MathProps {
  /** Display-name text with zero or more `$<latex>$` spans (see mathDisplay.ts). */
  text: string;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Renders a display-name string, typesetting any `$...$` spans as real KaTeX
 * math and leaving the rest as plain text. Used everywhere a variable/param
 * display name is shown as real DOM (dropdowns, headers) — NOT for ECharts
 * canvas titles/tooltips, which cannot render HTML (those use the bare
 * variable key instead).
 */
const Math: React.FC<MathProps> = ({ text, style, className }) => {
  const segments = useMemo(() => parseMathSegments(text), [text]);

  return (
    <span style={style} className={className}>
      {segments.map((seg, i) =>
        seg.math ? (
          <span
            key={i}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: katex.renderToString(seg.content, {
                throwOnError: false,
                output: 'html',
              }),
            }}
          />
        ) : (
          <React.Fragment key={i}>{seg.content}</React.Fragment>
        )
      )}
    </span>
  );
};

export default Math;
